import { render } from "./PaymentResult.vue?vue&type=template&id=ce8e5fe4&scoped=true"
import script from "./PaymentResult.vue?vue&type=script&lang=js"
export * from "./PaymentResult.vue?vue&type=script&lang=js"

import "./PaymentResult.vue?vue&type=style&index=0&id=ce8e5fe4&lang=scss&scoped=true"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8e5fe4"]])

export default __exports__